<template>
  <!--  设置套餐的菜品和差价	-->
  <div class="home">
    <van-nav-bar
      :title="$t('PackageDish.title')"
      left-arrow
      fixed
      @click-left="
        $router.push('/EditPackage/' + sessionStorage.actPackageTagId)
      "
    >
      <div slot="right">
        <van-button class="rightBtn" type="info" @click="showActionSheet('new')"
          >{{ $t("ShopList.add") }}
        </van-button>
        <van-button
          v-if="isCheckboxesShow == 'none'"
          class="rightBtn"
          type="danger"
          @click="isCheckboxesShow = 'block'"
          >{{ $t("ShopList.delete") }}
        </van-button>
        <van-button
          v-else
          class="rightBtn"
          type="danger"
          @click="isCheckboxesShow = 'none'"
          >{{ $t("PackageDish.cancel") }}
        </van-button>
      </div>
    </van-nav-bar>
    <van-checkbox-group v-model="dishResult" v-if="dishData">
      <draggable
        v-model="dishData"
        handle=".dragIcon"
        chosen-class="chosen"
        force-fallback="true"
        group="people"
        @start.stop="onStart"
        @end.stop="onEnd"
        :move="onMove"
      >
        <div
          style="border-bottom: 2px solid #ccc;"
          v-for="(dish, index) in dishData"
          :key="index"
        >
          <van-cell
            clickable
            class="textLeft noExceed"
            :key="index"
            :title="dish.name"
            @click="isCheckboxesShow == 'none' ? '' : toggle(index)"
          >
            <van-checkbox
              v-if="isCheckboxesShow != 'none'"
              :style="{ display: isCheckboxesShow, paddingRight: '10px' }"
              :name="index"
              ref="dish_checkboxes"
              slot="icon"
            >
              <img
                style="width: 20px;height: 20px"
                slot="icon"
                slot-scope="props"
                :src="
                  props.checked
                    ? './static/img/sele.png'
                    : './static/img/unsele.png'
                "
              />
            </van-checkbox>
            <van-icon
              v-else
              name="./static/img/drag.png"
              class="dragIcon"
              slot="icon"
            />
            <template slot="right-icon">
              <div class="tagSort">
                <van-icon
                  slot="right-icon"
                  @click="showActionSheet(index)"
                  size="25px"
                  name="arrow"
                />
              </div>
            </template>
          </van-cell>
          <van-field
            :label="$t('PackageDish.compensationPrice')"
            class="next_input_r noExceed"
            :placeholder="$t('PackageDish.inputMoney')"
            v-model="dish.fill_price"
          ></van-field>
        </div>
      </draggable>
    </van-checkbox-group>
    <van-action-sheet
      v-model="actionShow"
      :actions="dishs"
      :cancel-text="$t('PackageDish.cancel')"
      :title="$t('PackageDish.cook')"
      @select="onSelect"
      @cancel="onCancel"
    />
    <van-tabbar v-if="isCheckboxesShow == 'block'">
      <div style="width: 100%;height: 50px;">
        <div class="bottomBtn fl">
          <van-icon
            size="30px"
            @click="selectAll()"
            name="./static/img/all.png"
          />
        </div>
        <div class="bottomBtn fr">
          <van-icon
            size="30px"
            @click="delDish()"
            name="./static/img/Trash_s.png"
          />
        </div>
      </div>
    </van-tabbar>
    <van-tabbar v-if="isCheckboxesShow == 'none'">
      <van-button
        style="height: 35px;margin: 10px 3%;line-height: 35px;width: 94%;background: #000;color:#fff;"
        round
        @click="patchPackageDish('patch')"
        >{{ $t("PackageDish.save") }}</van-button
      >
    </van-tabbar>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      tagDishs: [],
      dishs: [],
      dishData: [],
      newDish: {
        id: "",
        name: "",
        fill_price: 0
      },
      actionShow: false,
      dishResult: [],
      isCheckboxesShow: "none",
      actIndex: ""
    };
  },
  mounted: function() {
    this.getTagDishs();
    this.getDishs();
  },
  methods: {
    getTagDishs() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/" + this.$route.params.id + "/getMenus"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.tagDishs = res.data.data;
            this.dishData = [];
            for (var i = 0; i < res.data.data.length; i++) {
              this.newDish.id = res.data.data[i].id;
              this.newDish.fill_price = res.data.data[i].pivot.fill_price;
              this.newDish.name = res.data.data[i].name;
              this.dishData.push(this.newDish);
              this.newDish = {
                id: "",
                name: "",
                fill_price: 0
              };
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("PackageDish.message")
          });
        });
    },
    getDishs() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/menus"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.dishs = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("PackageDish.message")
          });
        });
    },
    selectAll() {
      if (this.dishResult.length != this.dishData.length) {
        this.dishResult = [];
        for (var i = 0; i < this.dishData.length; i++) {
          this.dishResult.push(i);
        }
      } else {
        this.dishResult = [];
      }
    },
    addShow() {
      this.isCheckboxesShow = "none";
      // this.isAddShow=true;
    },
    delShow(index) {
      this.isCheckboxesShow = "block";
    },
    toggle(index) {
      this.$refs.dish_checkboxes[index].toggle();
    },
    addDishData() {
      if (this.newDish.id && this.newDish.fill_price >= 0) {
        this.dishData.push(this.newDish);
        this.newDish = {
          id: "",
          name: "",
          fill_price: 0
        };
      } else {
        this.$toast({
          type: "fail",
          message: this.newDish.id
            ? this.$t("PackageDish.inputCompensationPrice")
            : this.$t("PackageDish.pleaseChooseCook")
        });
      }
    },
    patchPackageDish(type) {
      this.$axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/menu/" + this.$route.params.id + "/addMenus",
        data: {
          data: JSON.stringify(this.dishData)
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.isCheckboxesShow = "none";
            this.$toast({
              type: "success",
              message: res.data.message
            });
            if (type == "patch") {
              this.$router.push(
                "/EditPackage/" + sessionStorage.actPackageTagId
              );
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("PackageDish.message")
          });
        });
    },
    delDish() {
      console.log(this.dishResult);
      if (this.dishResult.length > 0) {
        this.$dialog
          .confirm({
            title: this.$t("PackageDish.del"),
            message: this.$t("PackageDish.isDel"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            var newDishData = [];
            for (var i = 0; i < this.dishData.length; i++) {
              if (this.dishResult.indexOf(i) > -1) {
              } else {
                newDishData.push(this.dishData[i]);
              }
            }
            this.dishData = newDishData;
            this.patchPackageDish("del");
            this.dishResult = [];
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("PackageDish.chooseDelCategory")
        });
      }
    },
    showActionSheet(index) {
      this.actionShow = true;
      this.actIndex = index;
    },
    onSelect(item) {
      this.actionShow = false;
      console.log(item.id);
      if (this.actIndex == "new") {
        this.newDish.name = item.name;
        this.newDish.id = item.id;
        this.addDishData();
      } else {
        this.dishData[this.actIndex].id = item.id;
        this.dishData[this.actIndex].name = item.name;
      }
    },
    onCancel() {
      this.actionShow = false;
    },
    // 拖拽排序
    onStart(e) {
      this.drag = true;
      console.log(e, "开始");
    },
    onEnd(e) {
      this.disabled = true;
      this.data = {
        pivot_id: this.startItem.id,
        pivot_ids: this.endItem.id
      };
      let start, end;
      this.dishData.forEach((item, index) => {
        if (item.id == this.startItem.id) {
          start = index;
        } else if (item.id == this.endItem.id) {
          end = index;
        }
      });
      let arr = [];
      let temp = JSON.parse(JSON.stringify(this.dishData));
      console.log();
      this.dishData.forEach((item, index) => {
        if (index == end) {
          temp.splice(index, 1, this.dishData[start]);
        } else if (index == start) {
          temp.splice(index, 1, this.dishData[end]);
        }
      });

      console.log(temp, "查看数据");
      this.dishData = temp;
    },
    onMove(e, originalEvent) {
      //拖拽位置
      this.startItem = e.draggedContext.element;
      //停靠位置
      this.endItem = e.relatedContext.element;
      if (e.draggedContext.element) return false;
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field .van-icon {
  font-size: 20px;
}
/deep/ .van-cell__left-icon,
.van-cell__right-icon {
  font-size: 20px;
}
/deep/ .van-field__label {
  width: 150px;
}
/deep/ .van-cell__title {
  width: 100px;
}
/deep/ .van-action-sheet__name {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  /*设置内容不换行*/
  text-overflow: ellipsis;
  /*设置文字超出文本框的内容显示成...*/
  overflow: hidden;
  /*设置超出隐藏*/
}
/deep/ .van-cell__title > span {
  display: block;
  white-space: nowrap;
  /*设置内容不换行*/
  text-overflow: ellipsis;
  /*设置文字超出文本框的内容显示成...*/
  overflow: hidden;
  /*设置超出隐藏*/
}
/deep/ .van-checkbox-group {
  /* padding-top: 46px; */
  padding-bottom: 57px;
}
.home {
  width: 100%;
  height: 100vh;
}
.editBtn {
  position: absolute;
  right: 0px;
  top: 0px;
}
.tagInput {
  font-size: 14px;
  text-indent: 10px;
  width: 90%;
  height: 33px;
  line-height: 33px;
  border: 1px solid #ffc914;
  margin-left: 5%;
  border-radius: 5px;
}
.bottomBtn {
  width: 30px;
  height: 30px;
  margin: 10px 20px;
}
.next_input_r input {
  text-align: right;
  color: red;
}
.tagSort {
  width: 86px;
  display: flex;
  justify-content: space-around;
}
.dragIcon {
  position: relative;
  top: 20%;
  margin-right: 0.625rem;
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/Shop/PackageDish.vue